// Flag to track if panToNetworkBounds is currently active
// This helps prevent double-zoom issues by temporarily disabling other zoom mechanisms
export let isPanToNetworkBoundsActive = false;

/**
 * Sets the isPanToNetworkBoundsActive flag
 * @param value Boolean value to set
 */
export function setPanToNetworkBoundsActive(value: boolean): void {
  isPanToNetworkBoundsActive = value;
}
